import React, { Component, } from 'react'
import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import './../../styles/css/screens/Home/home.css'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {CCActions, FirebaseUtils, CCActivityIndicator, DataActionTypes as DataAT,  Constants, CCIcon, SimpleMatchDetails, strings, colors} from "./../../cc-imports";



class Home extends Component {

    static propTypes = {}

    static defaultProps = {}

    static navigationOptions = {
        gesturesEnabled: false
    }

    constructor(props) {
        super(props);
        this.state={
            selected : undefined
        };
        this._getListItems=this._getListItems.bind(this);

        this._fetchMatches=this._fetchMatches.bind(this);
        this._autoRefresh=this._autoRefresh.bind(this);
        this._manualRefresh=this._manualRefresh.bind(this);
        this._switchTab=this._switchTab.bind(this);
        this._playPressed=this._playPressed.bind(this);
        //this._onMatchesUpdate=this._onMatchesUpdate.bind(this);
    }

    componentDidMount() {
        this._fetchMatches(DataAT.GET);
        const {user, userId, actions}=this.props;

        if(user) {
            //console.log(Firebase.auth().currentUser);
            FirebaseUtils.getIdTokenWhenAuthChanged((idToken)=>{
                actions.getSponsorsByUserId(userId, DataAT.GET);
            });
        }

        /*this.setInterval(() => {
            this._fetchMatches(DataAT.AUTO_REFRESH);
        }, 60000);*/
    }

    _getListItems(){
        const {matchesByStatus, matchesById} = this.props;

        var upcomingMatches = matchesByStatus[Constants.matchStatus.NOT_STARTED] ? matchesByStatus[Constants.matchStatus.NOT_STARTED] : [];
        var liveMatches = matchesByStatus[Constants.matchStatus.STARTED] ? matchesByStatus[Constants.matchStatus.STARTED]: [];
        var completedMatches = matchesByStatus[Constants.matchStatus.COMPLETED] ?matchesByStatus[Constants.matchStatus.COMPLETED] : [];


        var matchIds = this.state.selected=='upcoming' ?  upcomingMatches : _.union(liveMatches,completedMatches);

        if (this.state.selected === 'upcoming') {
            matchIds = _.orderBy(matchIds,[(id)=>{return matchesById[id].priority}, (id)=>{return new Date(matchesById[id].date)}],['asc', 'asc']);
        }
        else {
            matchIds = _.orderBy(matchIds,[(id)=>{return matchesById[id].status==Constants.matchStatus.STARTED ? 10:0}, (id)=>{return matchesById[id].priority}, (id)=>{return new Date(matchesById[id].date)}],['desc', 'asc', 'desc']);
        }

        return matchIds;
    }

    // _getBgColor(tabname){
    //     if(this.state.selected === tabname) {
    //         return 'rgb(17, 49, 96)'
    //     }
    //     else {
    //         return 'rgb(52,105,184)'
    //     }
    // }
    _getBgColor(tabName){
        if(this.state.selected === tabName) {
            return colors.theme2.bg_color8;
        }
        else {
            return colors.theme2.bg_color9;
        }
    }

    _switchTab(tabName) {
        this.setState({selected : tabName})
    }

    _fetchMatches(type){

        this.props.actions.getRecentMatches(type).then(()=>{
            const {matchesByStatus, matchesById} = this.props;

            if( this.state.selected === undefined) {
                var liveMatches = matchesByStatus[Constants.matchStatus.STARTED];
                if(liveMatches && liveMatches.length>0){
                    this._switchTab('live');
                }
                else {
                    this._switchTab('upcoming');
                }
            }

            /*_.forIn(matchesById,(value, key)=>{
             if(this.unsubscribe[key]==undefined ) this.unsubscribe[key]=this.ref.doc(key).onSnapshot(this._onMatchesUpdate);
             })*/

        });
    }

    _autoRefresh(){
        this._fetchMatches(DataAT.AUTO_REFRESH);
    }

    _manualRefresh() {
        this._fetchMatches(DataAT.MANUAL_REFRESH);
    }

    _paginate() {
        //No pagination at the moment
       /* this._fetchMatches(DataAT.AUTO_REFRESH);
        this.setState({skip : this.state.skip+1});*/
    }

    _playPressed(matchId){
        this.props.actions.openLeagues(matchId);
    }


    render() {
        //console.log(Firebase.auth().currentUser);
        const {matchesReqStatus, matchesById, matchesType}=this.props;
        const styles=ccStyles.default;
        return (
            <div>



                <div className={'flex-container home-container'}>
                    <div style={{height:'100vh'}}>
                        {
                            (matchesReqStatus==Constants.reqStatus.PEN && matchesType==DataAT.GET && this._getListItems().length==0) ?

                                <div className={"flex-container activity-indicator"}>
                                    <CCActivityIndicator size={'m'}></CCActivityIndicator>
                                </div>
                                :
                                <div>
                                    <div className={'flex-container match-selection-container'}>
                                        <div className={'flex-container match-selection-container-1'}>
                                            <div className={'flex-container live-switcher-container'} onClick={()=>{this._switchTab('live')}} style={{backgroundColor:this._getBgColor('live')}}>
                                                <div className={'flex-container btn btn-container'}>
                                                    <div className={'home-icon-hide'}>
                                                        <CCIcon   type={"live"} className={"cc-home-icon-xx"} disabled={true}></CCIcon>
                                                    </div>

                                                    <h1 style={{marginLeft:5, fontSize:12}}>{strings('live')}</h1>
                                                </div>
                                            </div>
                                            <div  className={'flex-container btn upcoming-container'} onClick={()=>{this._switchTab('upcoming')}} style={{backgroundColor:this._getBgColor('upcoming')}}>
                                                <div className={'flex-container upcoming-container-1'}>
                                                    <div className={'bat_icon_hide'}>
                                                        <CCIcon  type={"upcoming"} className={"cc-upcomming-icon-xx"} disabled={true}></CCIcon>
                                                    </div>
                                                    <h1 style={{marginLeft:5, fontSize:12}}>{strings('upcoming')}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        {
                                            matchesReqStatus==Constants.reqStatus.PEN && matchesType==DataAT.GET && this._getListItems().length==0 ?
                                                <div><CCActivityIndicator size={'m'}/></div>
                                                :
                                                <div>
                                                    {
                                                        this._getListItems().map((match)=>{
                                                            return(<SimpleMatchDetails  scroll={this.props.scroll} showPlay={true} onPlayPress={()=>{ this.props.actions.openLeagues(match) }}  ccMatch={matchesById[match]} key={matchesById[match].id}></SimpleMatchDetails>)
                                                        })
                                                    }
                                                </div>

                                        }

                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
        storedDetails: state.storedDetails,
        fireBaseUser: state.fireBaseUser,

        user : state.user,
        userId : (state.user.user && state.user.user.id) ? state.user.user.id:Constants.anonymousUser,

        matchesById : state.matches.byId,
        matchesByStatus : state.matches.byStatus,
        matchesReqStatus : state.matches.reqStatus,
        matchesType : state.matches.type,

        leaguesById : state.leagues.byId,

        ccNavigation:state.ccNavigation,
        leaderBoard:state.leaderBoard,
        notifications: state.notifications
    }),
    (dispatch) => ({
        actions: bindActionCreators({ ...CCActions}, dispatch),
        dispatch: dispatch
    })
)(Home);


const ccStyles =
    {
        default:{
            iconStyle : {
                height : 40,
                width :40
            },
            imageStyle: {
                height:35,
                width:35
            }
        },
        s: {
            iconStyle : {
                height:35,
                width:35
            },
            imageStyle: {
                height:30,
                width:30
            }
        }
    };



// WEBPACK FOOTER //
// ./src/app/screens/Home/Home.js